import { render, staticRenderFns } from "./DepartamentosForm.vue?vue&type=template&id=1a11a79a&scoped=true"
import script from "./DepartamentosForm.vue?vue&type=script&lang=js"
export * from "./DepartamentosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11a79a",
  null
  
)

export default component.exports